<template>
  <el-select
    v-model="val"
    clearable
    filterable
    remote
    reserve-keyword
    size="small"
    placeholder="请输入学生姓名"
    :remote-method="remoteMethod"
    :loading="loading"
    @change="selectChange"
  >
    <el-option
      v-for="item in selectList"
      :key="item.id"
      :label="item.studentName"
      :value="item.id"
    >
    </el-option>
  </el-select>
</template>
<script>
export default {
  name: "StudentSelect",
  props: {
    value: {
      type: String
    }
  },
  data() {
    return {
      selectList: [],
      val: "",
      loading: false
    };
  },
  mounted() {
    this.remoteMethod("");
    this.val = this.value;
  },
  methods: {
    remoteMethod(query) {
      let self = this;
      //   if (query == '' && type) {
      //     self.selectList = []
      //   } else {
      self.getStudentList(query, function(val) {
        // console.log(val);
        self.selectList = val;
      });
      //   }
    },
    // 模糊查询学生列表数据
    async getStudentList(query, callback) {
      this.loading = true;
      var req = {
        studentName: query,
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getStudentSelectList(req, true);
      this.loading = false;
      console.log(res);
      if (res.code == 200) {
        callback(res.data || []);
      } else if (res.code == 101) {
        callback([]);
      } else {
        callback([]);
      }
    },
    selectChange(val) {
      this.$emit("change", val);
      this.$emit("input", val);
    }
  },
  watch: {
    value: function(nval) {
      this.remoteMethod("");
      this.val = nval;
    }
  }
};
</script>
<style scoped lang="scss"></style>
